let dirPath = 'static/games/page012_game1';

let configGame = {
  removeInCorrects: true,
  correctBlock: true,
  //autoCheckAllCorrect: true,
  rulesGame: {
    itemsConfig: {
      block: true,
    },
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    pickItems: 2,
    itemsGarbage: [{ idGroup: 'source', itemsConfig: { block: false } }],
    items: [
      {
        idGroup: 'mapa',
        idItem: 'legend',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source',
            idItem: '03',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook00' }],
          },
          {
            idGroup: 'source',
            idItem: '04',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook01' }],
          },
          {
            idGroup: 'source',
            idItem: '05',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook02' }],
          },
          {
            idGroup: 'source',
            idItem: '03',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook03' }],
          },
          {
            idGroup: 'source',
            idItem: '04',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook04' }],
          },
          {
            idGroup: 'source',
            idItem: '05',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook05' }],
          },
          //
          {
            idGroup: 'source',
            idItem: '00',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook10' }],
          },
          {
            idGroup: 'source',
            idItem: '01',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook11' }],
          },
          {
            idGroup: 'source',
            idItem: '02',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook12' }],
          },
          {
            idGroup: 'source',
            idItem: '00',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook13' }],
          },
          {
            idGroup: 'source',
            idItem: '01',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook14' }],
          },
          {
            idGroup: 'source',
            idItem: '02',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook15' }],
          },
          //
          {
            idGroup: 'source',
            idItem: '05',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook20' }],
          },
          {
            idGroup: 'source',
            idItem: '02',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook21' }],
          },
          {
            idGroup: 'source',
            idItem: '03',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook22' }],
          },
          {
            idGroup: 'source',
            idItem: '05',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook23' }],
          },
          {
            idGroup: 'source',
            idItem: '02',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook24' }],
          },
          {
            idGroup: 'source',
            idItem: '03',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook25' }],
          },
        ],
      },
    ],
  },
  layout: {
    itemsConfig: {
      positions: {
        margin: { left: 5, bottom: 5 },
      },
      background: {
        color: 'transparent',
        text: { textAlign: 'center', bold: true },
      },
    },
    groups: [
      {
        idGroup: 'mapa',
        background: {
          color: 'transparent',
          //     color: 'pink',
        },
        positions: {
          type: 'absolute',
          pos: { x: 100, y: 0, height: 750, width: 1700 },
        },
        items: [
          {
            id: 'legend',
            positions: {
              autoFit: true,
            },
            otherProperty: {
              hooks: {
                background: {
                  color: '#00000010',
                  // border: { color: '#1C9CFF', size: 1 },
                },
                positions: {
                  type: 'absolute',
                  pos: { height: 162, width: 172 },
                },
                items: [
                  {
                    id: 'hook00',
                    positions: { pos: { x: 500, y: 75 } },
                  },
                  {
                    id: 'hook01',
                    positions: { pos: { x: 680, y: 75 } },
                  },
                  {
                    id: 'hook02',
                    positions: { pos: { x: 860, y: 75 } },
                  },
                  {
                    id: 'hook03',
                    positions: { pos: { x: 860 + 180, y: 75 } },
                  },
                  {
                    id: 'hook04',
                    positions: { pos: { x: 860 + 180 + 180, y: 75 } },
                  },
                  {
                    id: 'hook05',
                    positions: { pos: { x: 860 + 180 + 180 + 180, y: 75 } },
                  },
                  //
                  {
                    id: 'hook10',
                    positions: { pos: { x: 500, y: 283 } },
                  },
                  {
                    id: 'hook11',
                    positions: { pos: { x: 680, y: 283 } },
                  },
                  {
                    id: 'hook12',
                    positions: { pos: { x: 860, y: 283 } },
                  },
                  {
                    id: 'hook13',
                    positions: { pos: { x: 860 + 180, y: 283 } },
                  },
                  {
                    id: 'hook14',
                    positions: { pos: { x: 860 + 180 + 180, y: 283 } },
                  },
                  {
                    id: 'hook15',
                    positions: { pos: { x: 860 + 180 + 180 + 180, y: 283 } },
                  },
                  //
                  {
                    id: 'hook20',
                    positions: { pos: { x: 500, y: 492 } },
                  },
                  {
                    id: 'hook21',
                    positions: { pos: { x: 680, y: 492 } },
                  },
                  {
                    id: 'hook22',
                    positions: { pos: { x: 860, y: 492 } },
                  },
                  {
                    id: 'hook23',
                    positions: { pos: { x: 860 + 180, y: 492 } },
                  },
                  {
                    id: 'hook24',
                    positions: { pos: { x: 860 + 180 + 180, y: 492 } },
                  },
                  {
                    id: 'hook25',
                    positions: { pos: { x: 860 + 180 + 180 + 180, y: 492 } },
                  },
                ],
              },
            },
          },
        ],
      },
      {
        idGroup: 'source',
        background: {
          color: 'transparent',
        },
        positions: {
          type: 'absolute',
          pos: { x: 100, y: 680 },
          autoFit: true,
          // columns: 1,
        },
        itemsConfig: {
          positions: {
            pos: { height: 162, width: 172 },
            margin: { right: 100 },
            // columns: 1,
          },
        },
        otherProperty: {
          clones: {
            cloneNumber: 9,
          },
        },
        items: [
          {
            id: '00',
            background: {
              image: { src: dirPath + '/img/00.png' },
            },
          },
          {
            id: '01',
            background: {
              image: { src: dirPath + '/img/01.png' },
            },
          },
          {
            id: '02',
            background: {
              image: { src: dirPath + '/img/02.png' },
            },
          },
          {
            id: '03',
            background: {
              image: { src: dirPath + '/img/03.png' },
            },
          },
          {
            id: '04',
            background: {
              image: { src: dirPath + '/img/04.png' },
            },
          },
          {
            id: '05',
            background: {
              image: { src: dirPath + '/img/05.png' },
            },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'dnd',
  // isDev: true,
  //   defaultConfig: dirPath + '/defaultConfig.json',
  realHeight: 840,
  //   realWidth: 1820,
  mainImage: {
    imagePath: dirPath + '/img/bgr.png',
    pos: {
      y: 60,
      x: 0,
    },
  },
  cssStyle: {
    overflow: 'hidden',
  },
  configGame: configGame,
};

export default dataConfig;
